import { useState } from "react";

interface ShareButtonsProps {
  title: string;
}

export default function ShareButtons({ title }: ShareButtonsProps) {
  const [toast, setToast] = useState("");

  const showToast = (message: string) => {
    setToast(message);
    window.setTimeout(() => setToast(""), 2200);
  };

  const handleCopy = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      showToast("已复制链接");
    } catch {
      showToast("复制失败，请手动复制地址");
    }
  };

  return (
    <div className="relative flex flex-wrap items-center gap-2">
      <span className="text-xs text-foreground-500">分享：</span>
      <button
        type="button"
        onClick={handleCopy}
        className="flex items-center gap-1 rounded-full bg-background-100 px-3 py-1.5 text-xs text-foreground-600 transition hover:bg-primary-100 hover:text-primary-700"
      >
        <i className="ri-link"></i>复制链接
      </button>
      <button
        type="button"
        onClick={() => showToast("已打开微博分享（演示）")}
        className="flex items-center gap-1 rounded-full bg-background-100 px-3 py-1.5 text-xs text-foreground-600 transition hover:bg-primary-100 hover:text-primary-700"
      >
        <i className="ri-weibo-line"></i>微博
      </button>
      <button
        type="button"
        onClick={() => showToast("请使用微信扫码分享（演示）")}
        className="flex items-center gap-1 rounded-full bg-background-100 px-3 py-1.5 text-xs text-foreground-600 transition hover:bg-primary-100 hover:text-primary-700"
      >
        <i className="ri-wechat-line"></i>微信
      </button>
      <span className="sr-only">{title}</span>
      {toast && (
        <span className="fixed bottom-24 left-1/2 z-50 -translate-x-1/2 animate-fade-in rounded-full bg-foreground-900 px-4 py-2 text-xs text-background-50">
          {toast}
        </span>
      )}
    </div>
  );
}